"use strict";
const config = {
    HOST: parse(process.env.VUE_APP_HOST, "localhost"),
    PORT: parse(process.env.VUE_APP_PORT, "8080"),
    MAIL_KEY: parse(process.env.VUE_APP_MAIL_KEY, ""),
    ADMINISTRATOR: parse(process.env.VUE_APP_ADMINISTRATOR, ""),
    features: {},
}

function feature(name) {
    return config.features[name];
}
function parse(value, fallback) {
    if (typeof value === "undefined") {
        return fallback;
    }
    switch (typeof fallback) {
        case "boolean":
            return !!JSON.parse(value);
        case "number":
            return JSON.parse(value);
        default:
            return value;
    }
}

export { config };
export default {
    install(Vue) {
        Vue.appConfig = config;
        Vue.feature = feature;
        Vue.prototype.$appConfig = config;
        Vue.prototype.$feature = feature;
    }
};
